
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_iykw5_1dqi5_141",
  "hide-focus": "awsui_hide-focus_iykw5_1dqi5_155"
};
  